export const formatTravelDuration = (durationSeconds: number, locale: string): string => {
  const minutes = Math.max(1, Math.round(durationSeconds / 60));

  if (minutes < 60) {
    return `${minutes.toLocaleString(locale)} min`;
  }

  const hours = Math.round((minutes / 60) * 10) / 10;
  return `${hours.toLocaleString(locale, { maximumFractionDigits: 1 })} hr`;
};

export const formatTravelDistance = (distanceMeters: number, locale: string): string => {
  const kilometres = Math.round((distanceMeters / 1000) * 10) / 10;
  return `${kilometres.toLocaleString(locale, { maximumFractionDigits: 1 })} km`;
};
